const topics = [
  {
    title: "-Motion-",
    subtitle1: "Topic: 1",
    description: "PS.1.1 Understand how forces (pushes or pulls) affect the motion of an object.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "(Chorus)",
"If an object changes its position,",
"Then a motion has occurred.",
"If it continuously changes its position,",
"Then it's in motion, then it's in motion.",

"(Verse)",
"Use a car as an example, and the car is parked at the curb.",
"Now, you move the car up 10 feet, then a motion has occurred.",
"Now, if you take the same parked car and put it on the highway,",
"Then start coasting.",
"Its position is constantly changing.",
"Then, it's in motion, then it's in motion.",

"(Chorus)",
"If an object changes its position,",
"Then a motion has occurred.",
"If it continuously changes its position,",
"Then it's in motion, then it's in motion.",
"If an object changes its position,",
"Then a motion has occurred.",
"If it continuously changes its position,",
"Then it's in motion, then it's in motion.",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Force-",
    subtitle1: "Topic: 2",
    description: "PS.1.1 Understand how forces (pushes or pulls) affect the motion of an object.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fforce.mp4?alt=media&token=d90d58e8-21a5-403e-9cb9-4d065fb9c655",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fforce2025song.mp3?alt=media&token=aeed54c4-234a-4568-800a-a2b8ab0c9b11",
    lyrics: ["(Chorus)",
"If you give a push or give a pull,",
"That is force to an object.",
"If you give a push or give a pull,",
"That is force to an object.",

"(Verse)",
"Force is a push or a pull that will,",
"Make an object stop.",
"Force is a push or a pull that will,",
"Change an object's speed.",
"Force is a push or a pull that will,",
"Change an object's direction.",
"Force is a push or a pull that will,",
"Change an object's direction.",

"(Chorus)",
"If you give a push or give a pull,",
"That is force to an object.",
"If you give a push or give a pull,",
"That is force to an object.",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
{
    title: "-The Magic of Magents-",
    subtitle1: "Topic: 3",
    description: "PS.1.1 Understand how forces (pushes or pulls) affect the motion of an object.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fthemagicofmagnets2025song.mp3?alt=media&token=6e1b89fd-f033-4760-8d31-049393533d52",
    lyrics: [
    "(Chorus)",
"Push or pull, what can we do?",
"Magnets move things, it’s true!",
"Close or far, they have the power,",
"Magnets amaze us every hour!",

"(Verse 1)",
"When magnets pull, they bring things near,",
"Metal moves close, it’s oh so clear.",
"A force you can’t see, but it’s strong and true,",
"Magnets are magic for me and you!",
"If magnets push, the objects go,",
"They move away, fast or slow.",
"No need to touch, it’s a force unseen,",
"Magnets are cool, they’re like a dream!",

"(Chorus)",
"Push or pull, what can we do?",
"Magnets move things, it’s true!",
"Close or far, they have the power,",
"Magnets amaze us every hour!",

"(Verse 2)",
"North and south, they play their part,",
"Attracting or repelling, they’re really smart.",
"At a distance or close, the motion’s clear,",
"Magnets show forces we can all cheer!",
"With a push or a pull, objects move,",
"Magnets make motion, they always prove.",
"Experiment, learn, and you’ll see,",
"Magnets are science and fun for me!",

"(Chorus)",
"Push or pull, what can we do?",
"Magnets move things, it’s true!",
"Close or far, they have the power,",
"Magnets amaze us every hour!",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-What Do Plants & AnimalsNeed-",
    subtitle1: "Topic: 4",
    description: "LS.1.1 Understand the basic needs of a variety of plants and animals in different ecosystems.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fwhatdoplantsneed2025video.mp4?alt=media&token=2172b66c-8868-45bf-8a14-dd8f6be2f4ec",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fwhatdoplantsneed2025song.mp3?alt=media&token=95132d97-2377-471a-9d92-9562b9dec2e7",
    lyrics: [
      "(Chorus)",
"Plants and animals change as they grow.",
"There are a few things we know",
"That they need for survival.",

"(Verse 1)",
"Animals need food and water.",
"Animals need food and water.",
"Animals need air and shelter.",
"Animals need air and shelter.",
"Some animals get their oxygen from the air.",
"That makes them terrestrial.",
"Some animals get their oxygen from the water.",
"That makes them aquatic.",

"(Chorus)",
"Plants and animals change as they grow.",
"There are a few things we know",
"That they need for survival.",

"(Verse 2)",
"Plants need air, light, water, and nutrients from the soil.",
"Plants need air, light, water, and nutrients from the soil.",
"Plants provide food for people.",
"Plants provide food for animals.",
"Plants can be aquatic.",
"Plants can be terrestrial.",

"(Chorus)",
"Plants and animals change as they grow.",
"There are a few things we know",
"That they need for survival.",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Things Plants Need-",
    subtitle1: "Topic: 5",
    description: "LS.1.1 Understand the basic needs of a variety of plants and animals in different ecosystems.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fthingsplantsneed2025song.mp3?alt=media&token=58839d9c-7e4f-40c7-bd9b-66865d87379b",
    lyrics: [
      "(Chorus)",
"What do plants need? Let’s find out!",
"Water, air, and light, no doubt.",
"Shelter and space to grow up tall,",
"Plants need these to give us all!",

"(Verse 1)",
"Plants need water to drink each day,",
"It helps their roots in every way.",
"They reach for light from the sun so bright,",
"It helps them grow both day and night!",

"(Chorus)",
"What do plants need? Let’s find out!",
"Water, air, and light, no doubt.",
"Shelter and space to grow up tall,",
"Plants need these to give us all!",

"(Verse 2)",
"Air is around, it helps them breathe,",
"It’s one more thing that plants do need.",
"With space to stretch and shelter near,",
"They grow so strong, year after year!",

"(Bridge)",
"Roots in the ground, leaves to the sky,",
"Plants grow tall and reach up high.",
"They need these things, it’s easy to see,",
"Water, air, light, and space are key!",

"(Chorus)",
"What do plants need? Let’s find out!",
"Water, air, and light, no doubt.",
"Shelter and space to grow up tall,",
"Plants need these to give us all!",

"(Outro)",
"So care for the plants, give them their space,",
"Water and sunlight in the right place.",
"Watch them grow, it’s fun to see,",
"Plants are special for you and me!",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Animals Need-",
    subtitle1: "Topic: 6",
    description: "LS.1.1 Understand the basic needs of a variety of plants and animals in different ecosystems.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fanimalneeds2025song.mp3?alt=media&token=53c6f12a-b401-47a5-b189-e4bcc774dc86",
    lyrics: [
      "(Chorus)",
"Basic needs of animals.",
"Basic needs of animals.",
"Basic needs of animals.",
"Basic needs of animals.",

"(Verse 1)",
"Basic needs of animals, no need to wonder,",
"For animals to survive, they need food, shelter, and water.",
"Basic needs of animals, no need to wonder,",
"For animals to survive, they need food, shelter, and water.",

"(Chorus)",
"Basic needs of animals.",
"Basic needs of animals.",
"Basic needs of animals.",
"Basic needs of animals.",

"(Verse 2)",
"Some animals need sunlight, like plants on the ground.",
"Others need oxygen, to keep them safe and sound.",
"Every living creature, big or small, it’s true,",
"Depends on their environment, just like me and you.",

"(Chorus)",
"Basic needs of animals.",
"Basic needs of animals.",
"Basic needs of animals.",
"Basic needs of animals.",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Plants and Animals Need Their Space-",
    subtitle1: "Topic: 7",
    description: "LS.1.1 Understand the basic needs of a variety of plants and animals in different ecosystems.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fplantsandanimalsneedtheirspace2025song.mp3?alt=media&token=006814cd-57d6-4312-b230-a84afa79a47f",
    lyrics: ["(Chorus)",
"Plants and animals need their space,",
"Water, food, and a safe, good place.",
"Hot or cold, it must feel right,",
"So, they can grow and live their life!",

"(Verse 1)",
"Animals need water, food, and air,",
"Shelter from rocks or trees they share.",
"Plants need sunlight, space to grow,",
"And bees to help their seeds to sow!",

"(Chorus)",
"Plants and animals need their space,",
"Water, food, and a safe, good place.",
"Hot or cold, it must feel right,",
"So, they can grow and live their life!",

"(Verse 2)",
"A small change can mean a lot,",
"Too little water, or too hot.",
"The parts of nature work as one,",
"Helping life get what’s to be done!",

"(Outro)",
"Living and nonliving work together,",
"For plants and animals, now and forever.",
"An ecosystem is a home, it’s true,",
"Taking care of it is up to me and you!",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "-Pollination-",
    subtitle1: "Topic: 8",
    description: "LS.1.1 Understand the basic needs of a variety of plants and animals in different ecosystems.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fpollination2025video.mp4?alt=media&token=305d1007-8fc2-4dee-84a2-36e27f0d4e86",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fpollination2025song.mp3?alt=media&token=ebc25acf-6a7e-474c-b3e8-7b916b11ee4f",
    lyrics: ["(Chorus)",
"My vocabulary.",
"My vocabulary.",

"(Verse)",
"Pollination, pollination, what’s up?",
"The transfer of pollen from one plant to another.",
"Pollination, pollination, what’s up?",
"The transfer of pollen from one plant to another.",
"Fertilization is the process of reproduction by pollination.",
"Fertilization is the process of reproduction by pollination.",
"Pollination, pollination, what’s up?",
"The transfer of pollen from one plant to another.",
"Pollination, pollination, what’s up?",
"The transfer of pollen from one plant to another.",
"Fertilization is the process of reproduction by pollination.",
"Fertilization is the process of reproduction by pollination.",

"(Chorus)",
"My vocabulary.",
"My vocabulary.",
"My vocabulary.",
"My vocabulary.",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "-Environmental Change-",
    subtitle1: "Topic: 9",
    description: "LS.1.1 Understand the basic needs of a variety of plants and animals in different ecosystems.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fenvironmentalchange2025song.mp3?alt=media&token=7fb064e4-0513-4dea-b929-47ff30f1e3e0",
    lyrics: ["(Chorus)",
"Organisms can thrive in changing environments,",
"If they adapt or move away, they still might stand a chance.",
"Organisms can thrive in changing environments,",
"But some may fail to live if they can't meet new demands.",

"(Verse 1)",
"Some organisms adapt to their surroundings' shift,",
"They change their behaviors or grow a special gift.",
"Adaptation.",
"But if the change is sudden and the shift is too extreme,",
"Some might not survive or fulfill their living dreams.",
"Extinction.",
"Some migrate to new spaces where conditions suit them more,",
"While others stay and perish where they were before.",
"Adaptation.",

"(Bridge)",
"If the food supply disappears or the water runs dry,",
"Life can become a struggle, and many might die.",
"But some species are resilient and can find a new way,",
"To make a home in places where others couldn’t stay.",

"(Chorus)",
"Organisms can thrive in changing environments,",
"If they adapt or move away, they still might stand a chance.",
"Organisms can thrive in changing environments,",
"But some may fail to live if they can't meet new demands.",

"(Verse 2)",
"When climates shift to heat waves or freezing snow and ice,",
"Some species can evolve, but others pay the price.",
"Natural Selection.",
"If pollution fills their waters or habitats are gone,",
"It creates new challenges to simply carry on.",
"Survival.",
"Genetics play a role in how species cope with change,",
"Some will grow stronger while others fade away.",
"Natural Selection.",

"(Outro)",
"Organisms rise or fall depending on their fate,",
"How they respond to changes can truly resonate.",
"Adapting or migrating, or even disappearing,",
"The story of survival is both harsh and endearing.",

"(Chorus)",
"Organisms can thrive in changing environments,",
"If they adapt or move away, they still might stand a chance.",
"Organisms can thrive in changing environments,",
"But some may fail to live if they can't meet new demands.",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "-Habitats-",
    subtitle1: "Topic: 10",
    description: "LS.1.1 Understand the basic needs of a variety of plants and animals in different ecosystems.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fhabitats2025song.mp3?alt=media&token=ac676b90-d3da-45be-8dcb-f0ad121b1ba0",
    lyrics: ["(Chorus)",
"Habitats are places with populations.",
"Habitats are where plants or animals live.",
"Habitats are places with populations.",
"Habitats are where plants or animals live.",

"(Verse)",
"In a habitat, you will find,",
"A group of organisms of the same kind,",
"Living together at the same time,",
"Living together.",
"Now that habitat supplies food,",
"Water, temperature just right,",
"Minerals—that’s right,",
"What organisms need to survive.",
"Ants have their own habitat (ant farms).",
"Bees have their own habitat (beehives).",
"Fish have their own habitats (water).",
"Toucans have a habitat (the rainforest).",

"(Chorus)",
"Habitats are places with populations.",
"Habitats are where plants or animals live.",
"Habitats are places with populations.",
"Habitats are where plants or animals live.",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "-Niche-",
    subtitle1: "Topic: 11",
    description: "LS.1.1 Understand the basic needs of a variety of plants and animals in different ecosystems.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fniche2025song.mp3?alt=media&token=2486f25c-f7c9-4419-9457-238a497c90ac",
    lyrics: ["(Chorus)",
"During an animal's life cycle, its niche can change,",
"During an animal's life cycle, its niche can change.",

"(Verse 1)",
"A niche is the role an animal plays in its ecosystem,",
"It’s where it finds its food and how it avoids the system.",
"It’s how it helps the environment, and how it survives,",
"Its niche is what keeps the ecosystem alive!",
"A tadpole eats plants, but a frog eats flies,",
"As it grows, its niche changes right before your eyes!",
"A caterpillar munches leaves, a butterfly drinks sweet nectar,",
"Different roles in nature, one creature’s life adventure!",

"(Chorus)",
"During an animal's life cycle, its niche can change,",
"During an animal's life cycle, its niche can change.",

"(Verse 2)",
"No two organisms can share the same niche, it’s true,",
"Each one has its own job that it’s meant to do.",
"From cleaning up the forest to pollinating flowers,",
"Every creature’s niche shows nature’s powers!",
"So remember, every animal has a special role,",
"Its niche helps the ecosystem stay whole.",
"From young to old, as they grow and rearrange,",
"During an animal’s life cycle, its niche can change!",

"(Chorus)",
"During an animal's life cycle, its niche can change,",
"During an animal's life cycle, its niche can change.",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "-Photosynthesis-",
    subtitle1: "Topic: 12",
    description: "LS.1.1 Understand the basic needs of a variety of plants and animals in different ecosystems.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fphotosynthesis2025video.mp4?alt=media&token=f1dd2985-8798-48a4-bac0-e8e9ad8cd07d",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fphotosynthesis2025song.mp3?alt=media&token=4c2bbcca-ccbe-4515-be6f-8604eb8bb65e",
    lyrics: ["(Chorus)",
"Photosynthesis is the process of how plants make food.",
"Photosynthesis is the process of how plants make food.",
"Photosynthesis is the process of how plants make food.",
"Photosynthesis is the process of how plants make food.",

"(Verse)",
"Energy coming from the sunlight, is what we need to get this started.",
"Water gathered by the roots right, is what we need to get this started.",
"Carbon dioxide from the air, is what we need to get this started.",
"Chlorophyll in the cells of green plants, is what we need to get this started.",
"The chlorophyll takes in the light from the sun.",
"The sun's energy splits the water into hydrogen and oxygen.",
"The hydrogen mixes with the carbon dioxide to make the food, yeah,",
"and the food is carried throughout the plant while the oxygen goes into the air.",

"(Chorus)",
"Photosynthesis is the process of how plants make food.",
"Photosynthesis is the process of how plants make food.",
"Photosynthesis is the process of how plants make food.",
"Photosynthesis is the process of how plants make food.",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "-Night & Day-",
    subtitle1: "Topic: 13",
    description: "ESS.1.1 Recognize the features and patterns of the earth/moon/sun system as observed from Earth.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fnightandday2025video.mp4?alt=media&token=0df32858-e1bd-4e92-9c18-dc595d6b52a9",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fdayandnight2025song.mp3?alt=media&token=2d2b7b35-895a-4226-8d35-bb5a2056564d",
    lyrics: ["(Intro)",
"Day and night, day and night, day and night, day and night.",
"Night and day, night and day, night and day, night and day.",

"(Chorus)",
"In the daytime, you see the light and it’s dark at night,",
"Yeah, it’s dark at night,",
"Yeah, yeah, it’s dark at night.",
"In the daytime, you see the light and it’s dark at night,",
"Yeah, it’s dark at night,",
"Yeah, yeah, it’s dark at night.",

"(Verse)",
"Because the Earth spins around,",
"And makes a full turn in 24 hours,",
"The sun only lights up half of the Earth at a time.",
"The side with the light is daytime.",
"The other side is dark—that’s nighttime.",
"As the Earth spins, daytime shifts to the other side.",
"As the Earth spins, nighttime shifts to the other side.",

"(Chorus)",
"In the daytime, you see the light and it’s dark at night,",
"Yeah, it’s dark at night,",
"Yeah, yeah, it’s dark at night.",
"In the daytime, you see the light and it’s dark at night,",
"Yeah, it’s dark at night,",
"Yeah, yeah, it’s dark at night.",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "-The Moon and the Sky-",
    subtitle1: "Topic: 14",
    description: "ESS.1.1 Recognize the features and patterns of the earth/moon/sun system as observed from Earth.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fthemoonandthesky2025song.wav?alt=media&token=5a3b8f24-5155-4a0e-9e22-1f7c3f4519e1",
    lyrics: ["(Chorus)",
"The moon and the sky, what do we see?",
"The sun, the stars, and the moon for you and me!",
"Daytime and nighttime, changes all the way,",
"The moon is so special, it shines both night and day!",

"(Verse 1)",
"The sun is bright, it lights the day,",
"The moon’s a little different, in its own way.",
"Sometimes at night, sometimes in the day,",
"The moon is up there, shining far away!",
"The stars come out when the sky is dark,",
"Twinkling brightly, like a glowing spark.",
"The moon has patterns, it changes its face,",
"A crescent, a circle, it’s a magical place!",

"(Chorus)",
"The moon and the sky, what do we see?",
"The sun, the stars, and the moon for you and me!",
"Daytime and nighttime, changes all the way,",
"The moon is so special, it shines both night and day!",

"(Verse 2)",
"From new moon to full, it grows so bright,",
"Then back to a crescent, fading from sight.",
"Day by day, it’s a wonderful show,",
"The moon’s always changing, just so you know!",
"So look at the sky, both day and night,",
"The sun, moon, and stars are such a delight.",
"Patterns to watch, the moon leads the way,",
"A part of our sky every single day!",

"(Chorus)",
"The moon and the sky, what do we see?",
"The sun, the stars, and the moon for you and me!",
"Daytime and nighttime, changes all the way,",
"The moon is so special, it shines both night and day!",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "-The Moon Changes-",
    subtitle1: "Topic: 15",
    description: "ESS.1.1 Recognize the features and patterns of the earth/moon/sun system as observed from Earth.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fthemoonchanges2025song.mp3?alt=media&token=d55c92a3-47bb-4952-8e4f-e8bb190b5023",
    lyrics: ["(Chorus)",
"The moon changes every night,",
"Sometimes big and sometimes bright.",
"It grows and shrinks, then starts again,",
"A glowing pattern that never ends!",

"(Verse 1)",
"At first, it’s small, just a tiny light,",
"Then it grows bigger, shining bright.",
"A full round moon, big and clear,",
"Then it starts to disappear.",
"Week by week, the moon will change,",
"Its glowing shape will rearrange.",
"Four weeks later, it’s back the same,",
"The moon’s repeating cycle is its name!",

"(Chorus)",
"The moon changes every night,",
"Sometimes big and sometimes bright.",
"It grows and shrinks, then starts again,",
"A glowing pattern that never ends!",

"(Verse 2)",
"Look at the moon, it’s fun to see,",
"Changing shapes for you and me.",
"Watch it closely, night by night,",
"The moon’s a pattern, a lovely sight!",

"(Chorus)",
"The moon changes every night,",
"Sometimes big and sometimes bright.",
"It grows and shrinks, then starts again,",
"A glowing pattern that never ends!",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "-The Sun's Day Journey-",
    subtitle1: "Topic: 16",
    description: "ESS.1.1 Recognize the features and patterns of the earth/moon/sun system as observed from Earth.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fthesunsdayjourney2025song.mp3?alt=media&token=7b7236bb-bcf7-4979-b694-aab50b290605",
    lyrics: ["(Chorus)",
"The sun, the sun, it lights our day,",
"Rising in the morning, shining all the way.",
"It moves through the sky, then says goodbye,",
"The sun is amazing, way up high!",

"(Verse 1)",
"In the morning, the sun will rise,",
"Peeking out from the eastern skies.",
"It shines so bright, it warms the air,",
"The sun is with us, everywhere!",
"By the afternoon, it’s way up high,",
"Right in the middle of the bright blue sky.",
"As the evening comes, it starts to set,",
"Glowing orange and red, it’s the prettiest yet!",

"(Chorus)",
"The sun, the sun, it lights our day,",
"Rising in the morning, shining all the way.",
"It moves through the sky, then says goodbye,",
"The sun is amazing, way up high!",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "-Earth's Layers-",
    subtitle1: "Topic: 18",
    description: "ESS.1.2 Understand the physical properties of Earth materials.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fearthslayers2025video.mp4?alt=media&token=fe620443-5bf0-4716-bcbb-c7fb0c6ddbbc",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fearthslayers2025song.mp3?alt=media&token=f018e154-c973-4646-9b31-82d3a0477aeb",
    lyrics: ["(Chorus)",
"Take a look inside the Earth,",
"Which layers do you see?",
"The crust, the mantle, the core.",

"(Verse)",
"The outer layer of the Earth is the crust.",
"That’s the part that we walk on.",

"The second layer of the Earth is the mantle.",
"It’s in a liquid rock form.",

"The third layer of the Earth is the core.",
"Inner core and outer core.",

"The third layer of the Earth is the core.",
"Inner core and outer core.",

"(Chorus)",
"Take a look inside the Earth,",
"Which layers do you see?",
"The crust, the mantle, the core.",
"Take a look inside the Earth,",
"Which layers do you see?",
"The crust, the mantle, the core.",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "-Soil, Soil, What Can You Do?-",
    subtitle1: "Topic: 19",
    description: "ESS.1.2 Understand the physical properties of Earth materials.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsoilsoilwhatcanyoudo2025song.mp3?alt=media&token=91c5d957-f41c-44f2-870a-c0f6eb120d00",
    lyrics: ["(Chorus)",
"Soil, soil, what can you do?",
"Soil, soil, it’s all up to you.",
"Helping plants live, helping plants grow.",
"Soil, soil, it’s all up to you.",

"(Verse 1)",
"Sandy soil is loose and light,",
"Water slips right through because sandy soil don’t hold tight.",
"It doesn’t hold much water, it’s dry and bare,",
"But mix it up, and plants grow there!",
"Clay is heavy, sticky, and slow,",
"It holds the water, it doesn’t let it go.",
"It’s harder for plants to grow in clay because roots need air,",
"But mix it with sand, and plants grow there!",
"Loam is perfect, the best of all,",
"It holds the water and lets roots crawl.",
"With nutrients rich and texture just right,",
"Plants grow strong, reaching new heights!",

"(Chorus)",
"Soil, soil, what can you do?",
"Help the plants grow, it’s up to you!",
"Some hold water, some stay dry,",
"Soil helps the roots reach up to the sky!",

"(Bridge)",
"Each soil is different, each one can bring,",
"Water, air, and nutrients for everything.",
"Soil supports the plants, helps them survive,",
"With the right soil, the plants will thrive!",
"So let’s learn about soil, it’s fun to know,",
"What helps our plants and gardens grow.",
"From sandy to clay, and loam so true,",
"Soil, soil, we depend on you!",

"(Chorus)",
"Soil, soil, what can you do?",
"Help the plants grow, it’s up to you!",
"Some hold water, some stay dry,",
"Soil helps the roots reach up to the sky!",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "-Rocks & Minerals-",
    subtitle1: "Topic: 20",
    description: "ESS.1.2 Understand the physical properties of Earth materials.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Frocksandminerals2025song.mp3?alt=media&token=908ef6b0-b264-49ea-b2d4-742bc97ebed9",
    lyrics: ["(Chorus)",
"We use rocks & minerals every day.",
"We use rocks & minerals every day.",
"We use rocks & minerals every day.",
"We use rocks & minerals every day.",

"(Verse 1)",
"Buildings and bridges are all made of rock.",
"Even the roads we drive on with our car.",
"Metals come from minerals.",
"Cars and planes use different minerals.",
"The salt on my food is a mineral.",
"The gold that I buy is a mineral.",
"Every day, we’re all around rocks and minerals.",
"Now, can you name some uses of rocks and minerals?",

"(Chorus)",
"We use rocks & minerals every day.",
"We use rocks & minerals every day.",
"We use rocks & minerals every day.",
"We use rocks & minerals every day.",

"(Verse 2)",
"Now all rocks are made up of two or more minerals,",
"But minerals aren't made up of rock.",
"Now all rocks are made up of two or more minerals,",
"But minerals aren't made up of rock.",
"There's about 3,000 minerals known on Earth,",
"And different combinations of them make rocks.",

"(Chorus)",
"We use rocks & minerals every day.",
"We use rocks & minerals every day.",
"We use rocks & minerals every day.",
"We use rocks & minerals every day.",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "-NC State Minerals-",
    subtitle1: "Topic: 21",
    description: "ESS.1.2 Understand the physical properties of Earth materials.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fncminerals2025song.mp3?alt=media&token=a3a81bd4-8811-46e9-a147-e19f25a92187",
    lyrics: ["(Chorus)",
"North Carolina’s ground is full of treasure, can’t you see?",
"Feldspar, Mica, Emerald, and Granite, shining brightly!",
"From the mountains to the coast, our minerals are the best,",
"North Carolina’s riches put us to the test!",

"(Verse 1)",
"Feldspar’s here, it’s in the clay, helping us make plates.",
"It’s found in all the shiny tiles we use to decorate.",
"Mica sparkles in the sun, it flakes and shines so bright,",
"We use it in electronics, it’s a mineral that’s just right!",
"Emeralds green and glowing, rare gems for all to see,",
"In the hills of Hiddenite, they sparkle brilliantly.",
"Granite is our solid rock, for buildings and for roads,",
"It gives our state the strength we need, it helps us bear the loads!",

"(Chorus)",
"North Carolina’s ground is full of treasure, can’t you see?",
"Feldspar, Mica, Emerald, and Granite, shining brightly!",
"From the mountains to the coast, our minerals are the best,",
"North Carolina’s riches put us to the test!",

"(Bridge)",
"From deep within the earth, these treasures show their worth,",
"Shaping all our lives, they come from North Carolina’s dirt.",
"Digging, mining, shining, our state’s so full of pride,",
"With these minerals, our history will never hide!",

"(Chorus)",
"North Carolina’s ground is full of treasure, can’t you see?",
"Feldspar, Mica, Emerald, and Granite, shining brightly!",
"From the mountains to the coast, our minerals are the best,",
"North Carolina’s riches put us to the test!",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "-Soil-",
    subtitle1: "Topic: 22",
    description: "ESS.1.2 Understand the physical properties of Earth materials.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsoil2025video.mp4?alt=media&token=3bca78d6-bf7e-41d8-aeac-e798bd67dc16",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsoil2025song.mp3?alt=media&token=228811c5-3593-4ea7-8753-cd5af3e86ffd",
    lyrics: ["(Chorus)",
"Going low, soil. Going low, soil.",
"Going low, soil. Going low, soil.",
"Getting down and dirty.",
"Getting down and dirty.",
"Getting down and dirty.",
"Getting down and dirty.",

"(Verse)",
"Soil is a mixture of organic materials, air, and water,",
"rocks broken down due to weathering,",
"remains of dead plants and animals, everything.",
"Soil covers a lot of Earth’s land.",
"A natural resource that’s important.",
"Soil gives plants the right nutrients,",
"so we can live, so we can live.",

"Microbes in the soil break down and decay,",
"dead organisms every day,",
"and many animals make their homes and shelters,",
"in soil every day.",

"(Chorus)",
"Going low, soil. Going low, soil.",
"Going low, soil. Going low, soil.",
"Getting down and dirty.",
"Getting down and dirty.",
"Getting down and dirty.",
"Getting down and dirty.",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "-Natural Resources-",
    subtitle1: "Topic: 24",
    description: "ESS.1.3 Understand that natural resources are important to humans.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fnaturalresources2025video.mp4?alt=media&token=41ca1ac8-d85f-4732-a6e8-31c0c0f5024f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fnaturalresources2025song.mp3?alt=media&token=970befde-e5f3-490c-b6b6-695a05fbb105",
    lyrics: ["(Chorus)",
"Natural resources are resources,",
"found in nature and used by people.",
"Natural resources are resources,",
"found in nature and used by people.",

"(Verse 1)",
"Renewable resources are trees, fish, and horses.",
"All plants and animals, well,",
"they reproduce and replace themselves.",
"Renewable resources are trees, fish, and horses.",
"All plants and animals, well,",
"they reproduce and replace themselves.",

"Nonrenewable resources are oil, gas, and coal.",
"They take millions of years to form,",
"so, once they’re used up, they’re gone.",
"Nonrenewable resources are oil, gas, and coal.",
"They take millions of years to form,",
"so, once they’re used up, they’re gone.",

"(Chorus)",
"Natural resources are resources,",
"found in nature and used by people.",
"Natural resources are resources,",
"found in nature and used by people.",

"(Verse 2)",
"An inexhaustible resource is sunlight.",
"It will always be around during our lifetime.",
"An inexhaustible resource is sunlight.",
"It will always be around during our lifetime.",

"Recyclable resources can be used more than once.",
"Some of these resources are copper, tin, and aluminum.",
"Recyclable resources can be used more than once.",
"Some of these resources are copper, tin, and aluminum.",

"(Chorus)",
"Natural resources are resources,",
"found in nature and used by people.",
"Natural resources are resources,",
"found in nature and used by people.",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "-Reduce, Reuse, and Recycle-",
    subtitle1: "Topic: 26",
    description: "ESS.1.3 Understand that natural resources are important to humans.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Freducereuseandrecycle2025video.mp4?alt=media&token=e70c95fb-a41d-41b7-b8c3-ef00cb03b098",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Freducereuserecycle2025song.mp3?alt=media&token=55526bc5-628f-4a12-94b4-b0b6ea6dda21",
    lyrics: ["(Chorus)",
"Reducing, reusing, and recycling protects your environment.",
"Reducing, reusing, and recycling protects your environment.",
"Reducing, reusing, and recycling can eliminate waste.",

"(Verse)",
"You can reduce by refusing store bags.",
"Carry small items out in your hands.",
"You can reuse cups that’s washable,",
"Instead of foam cups that’s disposable.",
"You can recycle papers and plastics, papers, and plastics,",
"Yup, yup, yup, papers and plastics.",

"(Chorus)",
"Reducing, reusing, and recycling protects your environment.",
"Reducing, reusing, and recycling protects your environment.",
"Reducing, reusing, and recycling can eliminate waste.",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },

];
export default topics;